var map = {
	"./Teacher_invite.svg": "35ee",
	"./Teacher_invite_accepted.svg": "e01b",
	"./Teacher_invite_accepted_dark.svg": "6273",
	"./Teacher_invite_dark.svg": "c85e",
	"./Teacher_invite_declined.svg": "869e",
	"./Teacher_invite_declined_dark.svg": "795f",
	"./arrows-icon.svg": "1613",
	"./check.svg": "f222",
	"./cross.svg": "89fe",
	"./danger-logo-dark.svg": "e53e",
	"./danger-logo.svg": "35c4",
	"./door-left-logo-dark.svg": "ab29",
	"./door-left-logo.svg": "7758",
	"./ekool-logo.svg": "a76e",
	"./eliis-logo.svg": "695c",
	"./email_not_updated_dark.svg": "d537",
	"./email_not_updated_light.svg": "3715",
	"./email_updated_dark.svg": "d61b",
	"./email_updated_light.svg": "e341",
	"./exclamation.svg": "89ca",
	"./fonts/permissions.svg": "3d9f",
	"./google-logo.svg": "7212",
	"./illustration-dark.svg": "6865",
	"./illustration.svg": "4901",
	"./info.svg": "07e6",
	"./key-icon--grayscale400.svg": "f4ae",
	"./key-icon--grayscale600.svg": "0f8b",
	"./key-icon-black.svg": "d2da",
	"./key-icon-white.svg": "216b",
	"./key-icon.svg": "afc7",
	"./letter-logo-white.svg": "3333",
	"./letter-logo.svg": "bcad",
	"./lock-locked-logo.svg": "bb6e",
	"./maintenance.svg": "8817",
	"./microsoft-logo.svg": "771b",
	"./passkey-logo-blue.svg": "ac12",
	"./passkey-logo-white.svg": "2bad",
	"./passkey-logo.svg": "0035",
	"./password_hide.svg": "60ae",
	"./password_show.svg": "35ab",
	"./phone-logo-white.svg": "ac6b",
	"./phone-logo.svg": "18dd",
	"./protected-logo.svg": "7057",
	"./shape.svg": "bedf",
	"./sms-logo-white.svg": "3e94",
	"./sms-logo.svg": "880b",
	"./spinner.svg": "5c3d",
	"./welcome.svg": "a50b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";